package model

//import msgAviso
import ffMsgAviso
import utils.*
import utils.ff.Companion.giEmpresa
import utils.ff.Companion.println0

open class Notas {
    var NOT_EMPRESA = 0
    var NOT_OF = 0
    var NOT_CLIENTE = 0
    var NOT_NRNOTA = 0
    var NOT_FUNC = 0
    var NOT_DTEMI = ff.InicialDate
    var NOT_DTVIG = ff.InicialDate
    var NOT_DTAGENDADO = ff.InicialDate
    var NOT_CPAG = 0
    var NOT_FPAG = 0
    var NOT_CFOCOD = ""
    var NOT_RAZAO = ""
    var NOT_ENDER = ""
    var NOT_NUMERO = ""
    var NOT_BAIRRO = ""
    var NOT_CEP = ""
    var NOT_CIDADE = ""
    var NOT_UF = ""
    var NOT_CNPJ = ""
    var NOT_IE = ""
    var NOT_TOTPROD = 0.0
    var NOT_TOTNOTA = 0.0
    var NOT_CHAVEACESSO = ""
    var NOT_USUCAD = ""
    var NOT_FINALIDADE = 0
    var NOT_CFODES = ""
    var NOT_QTCONF = ""
    var NOT_FATLOTE = 0
    var NOT_QTVOLUMES = 0
    var NOT_IDENTREGA = 0
    var NOT_TRANSP = ""
    var NOT_ENTRSEQUENCIA = 0
    var NOT_NOTATIPO = ""
    var NOT_PEDCOM = 0
    var NOT_DTSEPAFIM = ff.InicialDate

    //outros campos
    var CLI_SHELFLIFE00 = 0
    var REG_DESCR00 = ""
    var MOTO_NOME00 = ""
    var INOT_QTD00 = 0.0

    var OO_COUNT = 0
    var OO_CLIENTE = ""

    fun construtorLista(_it: String): List<Notas> {

        //var iLinha = 0
        //ff.println0("iniciou construtorLista")
        val it = if (_it.ffCopy(1,1).equals("[")) _it else "[$_it]"

        val lObj = ArrayList<Notas>()
        if ((!it.equals(null)) && (!it.equals(""))) {
            //ff.println0("Zuza aqui " + it)
            val lista = JSON.parse<Array<dynamic>>(it)
            //ff.println0("Zuza aqui1 " + it)

            try {
                lista.forEach {
                    val o = Notas()

                    o.NOT_EMPRESA = it.NOT_EMPRESA.toString().ffVsi()
                    o.NOT_OF = it.NOT_OF.toString().ffVsi()
                    o.NOT_CLIENTE = it.NOT_CLIENTE.toString().ffVsi()
                    o.NOT_NRNOTA = it.NOT_NRNOTA.toString().ffVsi()
                    o.NOT_FUNC = it.NOT_FUNC.toString().ffVsi()
                    o.NOT_DTEMI = it.NOT_DTEMI.toString().ffDsd()
                    o.NOT_DTVIG = it.NOT_DTVIG.toString().ffDsd()
                    //println0("zuza999 " + it.NOT_DTAGENDADO.toString())
                    o.NOT_DTAGENDADO = it.NOT_DTAGENDADO.toString().ffDsd()

                    o.NOT_CPAG = it.NOT_CPAG.toString().ffVsi()
                    o.NOT_FPAG = it.NOT_FPAG.toString().ffVsi()
                    o.NOT_CFOCOD = it.NOT_CFOCOD.toString().ffVss()
                    o.NOT_RAZAO = it.NOT_RAZAO.toString().ffVss()
                    o.NOT_ENDER = it.NOT_ENDER.toString().ffVss()
                    o.NOT_NUMERO = it.NOT_NUMERO.toString().ffVss()
                    o.NOT_BAIRRO = it.NOT_BAIRRO.toString().ffVss()
                    o.NOT_CEP = it.NOT_CEP.toString().ffVss()
                    o.NOT_CIDADE = it.NOT_CIDADE.toString().ffVss()
                    o.NOT_UF = it.NOT_UF.toString().ffVss()
                    o.NOT_CNPJ = it.NOT_CNPJ.toString().ffVss()
                    o.NOT_IE = it.NOT_IE.toString().ffVss()
                    o.NOT_TOTPROD = it.NOT_TOTPROD.toString().ffVsdo()
                    o.NOT_TOTNOTA = it.NOT_TOTNOTA.toString().ffVsdo()
                    o.NOT_CHAVEACESSO = it.NOT_CHAVEACESSO.toString().ffVss()
                    o.NOT_USUCAD = it.NOT_USUCAD.toString().ffVss()
                    o.NOT_FINALIDADE = it.NOT_FINALIDADE.toString().ffVsi()
                    o.NOT_CFODES = it.NOT_CFODES.toString().ffVss()
                    o.NOT_QTCONF = it.NOT_QTCONF.toString().ffVss()
                    o.NOT_FATLOTE = it.NOT_FATLOTE.toString().ffVsi()
                    o.NOT_QTVOLUMES = it.NOT_QTVOLUMES.toString().ffVsi()
                    o.NOT_IDENTREGA = it.NOT_IDENTREGA.toString().ffVsi()
                    o.NOT_TRANSP = it.NOT_TRANSP.toString().ffVss()
                    o.NOT_ENTRSEQUENCIA = it.NOT_ENTRSEQUENCIA.toString().ffVsi()
                    o.NOT_NOTATIPO = it.NOT_NOTATIPO.toString().ffVss()
                    o.NOT_PEDCOM = it.NOT_PEDCOM.toString().ffVsi()
                    o.NOT_DTSEPAFIM = it.NOT_DTSEPAFIM.toString().ffDsd()
                    //println0("@investigar it = ${it.NOT_DTSEPAFIM} obj = ${o.NOT_DTSEPAFIM}")

                    o.CLI_SHELFLIFE00 = it.CLI_SHELFLIFE00.toString().ffVsi()
                    o.REG_DESCR00 = it.REG_DESCR00.toString().ffVss()
                    o.MOTO_NOME00 = it.MOTO_NOME00.toString().ffVss()
                    o.INOT_QTD00  = it.INOT_QTD00.toString().ffVsdo()

                    o.OO_COUNT  = it.OO_COUNT.toString().ffVsi()
                    o.OO_CLIENTE  = o.NOT_CLIENTE.toString() + " - " + o.NOT_RAZAO
                    lObj.add(o)
                }
            } catch (e: Exception) {
                println("catch do NOTAS()" + e.message)
            }
        }
        //println0(lObj)
        //ff.println0("Terminou construtorLista")
        return lObj
    }

    fun getNota00(_recurso: String, cb: (List<Notas>) -> Unit) {
        Service().getString(_recurso) { _sResult ->
            //ff.println0(_sResult)
            cb(construtorLista(_sResult))
        }
    }

    fun getNotasSelect(_sql: String, cb: (List<Notas>) -> Unit) {

        Service().getSelect(_sql) { _sResult ->

            cb(construtorLista(_sResult))
            println0(_sResult)
        }
    }

    fun consultarNFe(_nota: String, callback: (Notas) -> Unit ) {

        console.log("try consultarNFe ${_nota}")

        //var oNota = Notas()
        if (_nota.equals("")) {
            ffMsgAviso("Informe a chave!")
        } else {
            getNota00("notas/011/${ff.giEmpresa}/${_nota}") { lobj ->
                if (lobj.size > 0) {
                    val oNota = lobj.get(0)
                    callback(oNota)
                } else {
                    callback(Notas())
                }
                //return oNota
            }
        }
    }

    fun queryAgendamentoCount(_iDias: Int, callback: (String) -> Unit) {
       val sSQL = "select count(*)campo\n" +
               "from notas n\n" +
               "where n.not_empresa = 1\n" +
               "and n.not_dtvig is null\n" +
               "and n.not_dtagendado >= GetDate() - 1 and n.not_dtagendado <= GetDate()"

        Service().getSelectCampo(sSQL) { _sResult ->
            callback(_sResult)
        }
    }

    fun queryAgendamento(_iDias: Int): String {
        /*
        val sSQL = "select n.not_nrnota, n.not_of, n.not_dtemi, n.not_dtagendado, n.not_cliente, n.not_razao \n" +
                " from notas n\n" +
                " join cliente c on c.cli_empresa = n.not_empresa and c.id_cliente = n.not_cliente\n" +
                " where n.not_empresa = " + ff.giEmpresa +
                " and n.not_dtvig is null" +
                " and n.not_dtagendado >= GetDate() - 1 and n.not_dtagendado <= GetDate() + $_iDias" +
                " order by not_dtagendado"

         */

        val sSQL = "select n.not_nrnota, n.not_of, n.not_dtemi, n.not_dtagendado, n.not_cliente, n.not_razao," +
                " sum(i.inot_qtd)inot_qtd00, count(*)OO_COUNT,\n" +
                " n.not_pedcom\n" +
                " from notas n\n" +
                " join cliente c on c.cli_empresa = n.not_empresa and c.id_cliente = n.not_cliente\n" +
                " join inotas i on i.inot_empresa = n.not_empresa and i.inot_of = n.not_of\n" +
                " where n.not_empresa = $giEmpresa\n" +
                " and n.not_dtvig is null\n" +
                " and cast(n.not_dtagendado as date) between GetDate() - 1 and GetDate() + $_iDias\n" +
                " group by n.not_nrnota, n.not_of, n.not_dtemi, n.not_dtagendado, n.not_cliente, n.not_razao, n.not_pedcom \n" +
                " union \n" +
                "select (0), (0), p.pedcom_dataprev, p.pedcom_dtagendado, p.pedcom_fornec, c.cli_fant," +
                " sum(i.ipedcom_qtd), count(*)OO_COUNT,\n" +
                " concat(p.pedcom_ano, replicate('0', 6 - LEN(p.pedcom_nr)) + rtrim(p.pedcom_nr))\n" +
                " from pedcompra p\n" +
                " join cliente c on c.cli_empresa = p.pedcom_empresa and c.id_cliente = p.pedcom_fornec\n" +
                " join ipedcompra i on i.ipedcom_empresa = p.pedcom_empresa and i.ipedcom_ano = p.pedcom_ano and i.ipedcom_nr = p.pedcom_nr\n" +
                " where p.pedcom_empresa = $giEmpresa\n" +
                " and p.pedcom_dtentr is null\n" +
                " and cast(p.pedcom_dtagendado as date) between GetDate() - 1 and GetDate() + $_iDias\n" +
                " group by p.pedcom_dataprev, p.pedcom_dtagendado, p.pedcom_fornec, c.cli_fant, p.pedcom_ano, p.pedcom_nr\n" +
                " order by not_dtagendado, not_of desc"

        return sSQL
    }

}